import instanceQuery from 'graphql/queries/supplier/PurchaseInvoicePostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const PurchaseInvoicePostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default PurchaseInvoicePostingPreview;
